<template>
<button
  v-if="isLottery && $can('events.lottery')"
  :disabled="insufficientTickets"
  @click="handleRunLottery()"
  class="btn btn-fill btn-wd btn-success btn-block"
>
  Realizar Sorteio
</button>
</template>

<script>
import swal from 'sweetalert2'
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'btn-run-lottery',

  computed: {
    ...mapGetters(['config']),

    ...mapGetters('tickets', {
      tickets: 'tickets'
    }),

    ...mapGetters('events', {
      event: 'event'
    }),

    canRunLottery () {
      let validNumRefrigerators = this.tickets.length >= this.event.numberOfRefigerators
      let validDrawn = this.event.drawn === false || this.event.drawn === undefined
      return validNumRefrigerators && validDrawn
    },

    isLottery () {
      return this.event.winnerChoiceMode === 'lottery' || this.event.winnerChoiceMode === ''
    },

    insufficientTickets () {
      return !this.tickets || this.tickets.length <= 0 || this.tickets.filter(item => {
        return item.eligible
      }) < this.event.numberOfRefigerators
    }
  },

  methods: {
    ...mapActions(['changeExecution']),

    ...mapActions('tickets', {
      runLottery: 'runLottery',
      fetchTickets: 'fetchAll'
    }),

    async handleRunLottery () {
      const where = [{
        eventId: this.event._id
      }]
      if (!this.config.customersCanBeRecontemplated) {
        where.push({eligible: true})
      }
      const tickets = await this.fetchTickets({
        where,
        limit: 99999
      })

      if (this.verifyIfCanRun(tickets)) {
        this.notifyProgress(tickets)
      }
    },

    notifyProgress (tickets) {
      swal({
        title: 'Confirmação',
        html: `O sorteio está preste a ser realizado. Por favor, confirme sua execução.`,
        type: 'info',
        confirmButtonText: 'Sortear!',
        showCloseButton: true,
        showConfirmButton: true,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          await this.runLottery({tickets: tickets, event: this.event})
            .then((res) => {
              if (res.hasOwnProperty('error')) {
                return swal('Erro', res.error, 'error')
              }

              swal('Sucessso', 'Sorteio realizado com sucesso. Em alguns instantes a página será recarregada.', 'success')
              this.$emit('fetchTicktes')
            })
            .catch(err => {
              console.log(err)
              this.swalLotteryFails(err)
            })
          return 'ok'
        }
      }).then(() => {
        setTimeout(function () {
          location.reload()
        }, 3000)

        swal({
          title: 'Quase finalizando',
          text: 'O processo está quase finalizando, aguarde o fim.',
          type: 'info',
          showConfirmButton: false
        })
      })
    },

    verifyIfCanRun (tickets) {
      if (tickets.length < this.event.numberOfRefigerators) {
        this.swalLowCustomersNumber()
        return false
      } else if (this.event.drawn === true) {
        this.swalLotteryAlreadyRan()
        return false
      } else if (tickets.length <= 0) {
        this.swalLotteryUnable()
        return false
      }
      return this.canRunLottery
    },

    swalLowCustomersNumber () {
      return swal({
        title: '',
        text: `Para efetuar o sorteio é preciso de pelo menos ${this.event.numberOfRefigerators} ticket(s) apto(s) a participar(em).`,
        type: 'error',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      })
    },

    swalLotteryAlreadyRan () {
      return swal({
        title: '',
        text: `Sorteio já realizado para esse evento.`,
        type: 'error',
        confirmButtonClass: 'btn btn-info btn-fill',
        buttonsStyling: false
      })
    },

    swalLotteryUnable () {
      return swal({
        title: 'Impossível fazer sorteio.',
        text: 'Não há clientes aptos a participar do sorteio',
        type: 'info'
      })
    },

    swalLotteryFails (err) {
      return swal({
        width: 1000,
        title: 'Ocorreu um erro ao realizar sorteio.',
        text: JSON.stringify(err),
        type: 'error',
        confirmButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Events/Actions/BtnRunLottery.vue